









































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  PictureBookController,
  SchoolController,
  SemesterController,
} from '@/services/request.service'
import moment from 'moment'
import { fileUploader } from '@/services/qiniu.service.new'
import { saveAs } from 'file-saver'
import { mapGetters } from 'vuex'
import RangePicker from '@/components/RangePicker.vue'
import SelectableCell from './SelectableCell.vue'
import UUID from 'uuidjs'
import { book } from '@/router'
import cloneDeep from 'lodash/cloneDeep'

@Component({
  components: {
    RangePicker,
    SelectableCell,
  },
  computed: {
    ...mapGetters(['getProgress']),
  },
})
export default class MIBPDetail extends Vue {
  private loading = false
  private bundleName = ''
  private bundleEnName = ''
  private bookNum = ''
  private suitableSection = ''
  private bookList: Array<any> = []
  private fileList: Array<any> = []
  private attachmentVisible = false
  private attachmentModalTitle = ''
  private activeBookId = 0
  private activeType = ''
  private bookDates: Array<any> = []
  private selectDateVisible = false
  private currentBookId = 0
  private schools: Array<any> = []
  private startTime = ''
  private endTime = ''
  private moment = moment

  private get locale(): string {
    return this.$store.state.locale
  }

  private get bundleId(): number {
    return parseInt(this.$route.params.bundleId, 10)
  }

  private get pictureBookHeader(): Array<any> {
    return [
      {
        title: this.$t('mibp.bookName'),
        width: '25%',
        scopedSlots: {
          customRender: 'name',
        },
      },
      {
        title: this.$t('mibp.openDate'),
        width: '20%',
        align: 'center',
        scopedSlots: {
          customRender: 'openDate',
        },
      },
      {
        title: this.$t('mibp.mibp'),
        width: '25%',
        align: 'center',
        scopedSlots: {
          customRender: 'mibp',
        },
      },
    ]
  }

  private get fileHeader(): Array<any> {
    return [
      {
        title: this.$t('mibp.file'),
        width: '40%',
        scopedSlots: {
          customRender: 'file',
        },
      },
      {
        title: this.$t('common.school'),
        width: '30%',
        scopedSlots: {
          customRender: 'school',
        },
      },
      {
        title: this.$t('common.operations'),
        width: '30%',
        align: 'center',
        scopedSlots: {
          customRender: 'operations',
        },
      },
    ]
  }

  private get selectDateHeader(): Array<any> {
    return [
      {
        title: this.$t('common.school'),
        width: '60%',
        scopedSlots: {
          customRender: 'name',
        },
      },
      {
        title: this.$t('mibp.openDate'),
        width: '40%',
        align: 'center',
        scopedSlots: {
          customRender: 'openDate',
        },
      },
    ]
  }

  private created(): void {
    this.bundleName = this.$route.query.name as string
    this.bundleEnName = this.$route.query.enName as string
    this.bookNum = this.$route.query.num as string
    this.suitableSection = this.$route.query.targetSection as string
    this.getBookList()
    this.getSchoolList()
    this.getNowSchoolYear()
  }
  // 获取当前时间
  private getNowSchoolYear(): void {
    SemesterController.getSchoolYearInfoByMonth(moment().valueOf())
      .then(res => {
        console.log('shijian', res)
        this.endTime = moment(res.data.endTime).format('YYYY-MM-DD')
        this.startTime = moment(res.data.startTime).format('YYYY-MM-DD')
      })
      .catch(err => {
        console.log(err)
      })
  }
  // 限制时间
  private disabledDate(current): boolean {
    return (
      current < moment(this.startTime).startOf('day') || current > moment(this.endTime).endOf('day')
    )
  }
  private getBookList(): void {
    PictureBookController.getPictureBundle(this.bundleId)
      .then(res => {
        this.bookList = res.data
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private getSchoolList(): void {
    SchoolController.getByFeature('MULTIIBP')
      .then(res => {
        this.schools = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private viewBook(bookId): void {
    this.$router.push({ name: 'book', params: { bookId } }).catch(err => {})
  }

  private selectDate(bookId): void {
    PictureBookController.getBookOpenDates(bookId)
      .then(res => {
        this.currentBookId = bookId
        this.bookDates = res.data.map(item => {
          return {
            school: item.school,
            openDate: moment(item.openDate),
          }
        })
        this.selectDateVisible = true
      })
      .catch(err => {
        console.error(err)
      })
  }

  private changeOpenDate(record, date): void {
    const { school } = record
    const request = {
      bookId: this.currentBookId,
      schoolId: school.schoolId,
      openDate: date.valueOf(),
    }
    PictureBookController.updateOpenDate(request)
      .then(res => {
        this.$message.success(this.$tc('common.saveSuccess'))
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private openPlans(bookId, enName, name): void {
    this.attachmentVisible = true
    this.attachmentModalTitle =
      enName + ' ' + name + this.$t('mibp.has') + ' ' + this.$t('mibp.lessonPlans')
    this.activeBookId = bookId
    this.activeType = 'LessonPlan'
    PictureBookController.getPictureBookResources(bookId, 'LessonPlan')
      .then(res => {
        this.fileList = res.data.map(item => {
          return {
            ...item,
            schoolIds: item.schools.map(school => school.schoolId),
          }
        })
      })
      .catch(err => {
        console.error(err)
      })
  }

  private openReivew(bookId, enName, name): void {
    this.attachmentVisible = true
    this.attachmentModalTitle =
      enName + ' ' + name + this.$t('mibp.has') + ' ' + this.$t('mibp.monthlyReview')
    this.activeBookId = bookId
    this.activeType = 'MonthlyReview'
    PictureBookController.getPictureBookResources(bookId, 'MonthlyReview')
      .then(res => {
        this.fileList = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private openStudentBook(bookId, enName, name): void {
    this.attachmentVisible = true
    this.attachmentModalTitle =
      enName + ' ' + name + this.$t('mibp.has') + ' ' + this.$t('mibp.studentBook')
    this.activeBookId = bookId
    this.activeType = 'StudentBook'
    PictureBookController.getPictureBookResources(bookId, 'StudentBook')
      .then(res => {
        this.fileList = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private beforeFileUpload(file: any): boolean {
    const index = file.name.lastIndexOf('.')
    const suffix = file.name.slice(index).toLowerCase()
    const originName = file.name.slice(0, index).toLowerCase()
    const fileName = 'file_' + new Date().getTime() + '_' + UUID.genV4() + suffix
    const suffixArray = [
      '.pdf',
      '.docx',
      '.doc',
      '.xls',
      '.xlsx',
      '.ppt',
      '.pptx',
      '.jpg',
      '.jpeg',
      '.png',
      '.mp3',
      '.wmv',
      '.mp4',
      '.mov',
    ]
    const PreSchool = this.schools.filter(item => item.type === '1230')
    if (suffixArray.includes(suffix)) {
      if (file.size > 104857600) {
        this.$message.error(this.$tc('mibp.attachmentOverLimit'))
      } else {
        let fileList = this.fileList
        fileList.push({
          resourceId: Math.random() * -1,
          resourceName: file.name,
          resourceSize: file.size,
          resourceUrl: '',
          fileName,
          schools: PreSchool,
        })
        this.fileList = fileList
        const index = fileList.findIndex(item => item.resourceName === file.name)
        fileUploader(file, fileName, 'file')
          .then(res => {
            fileList[index].resourceId = res.resourceId
            fileList[index].resourceUrl = process.env.VUE_APP_FILE_URL + '/' + res.key
            this.fileList = fileList
            const pictureBookId = this.activeBookId
            const type = this.activeType
            const resourceId = res.resourceId
            const schoolIds = PreSchool.map(school => school.schoolId)
            PictureBookController.addPictureBookResources({
              pictureBookId,
              type,
              resourceId,
              schoolIds,
            })
              .then(res => {
                this.getBookList()
                this.getSchoolList()
                PictureBookController.getPictureBookResources(pictureBookId, this.activeType)
                  .then(res => {
                    this.fileList = res.data.map(item => {
                      return {
                        ...item,
                        schoolIds: item.schools.map(school => school.schoolId),
                      }
                    })
                  })
                  .catch(err => {
                    console.error(err)
                  })
                this.$message.success(this.$tc('common.uploadSuccess'))
              })
              .catch(err => {
                console.warn(err)
              })
          })
          .catch(err => {
            console.warn(err)
          })
      }
    } else {
      this.$message.error(this.$tc('mibp.uploadCorrectAttachment'))
    }
    return false
  }

  private updateSchool(record, value): void {
    const { bookResourceId } = record
    let schoolList = cloneDeep(this.schools)
    let fileList = cloneDeep(this.fileList)
    const target = fileList.find(item => item.bookResourceId === bookResourceId)
    const request = {
      bookResourceId: bookResourceId,
      schoolIds: value,
    }

    PictureBookController.updateResourceSchool(request)
      .then(res => {
        const newSchools = schoolList.filter(school => value.includes(school.schoolId))
        if (target) {
          target['schools'] = newSchools
          this.fileList = fileList
        }
        this.getBookList()
        this.getSchoolList()
        this.$message.success(this.$tc('common.saveSuccess'))
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private download(resourceUrl, resourceName): void {
    saveAs(resourceUrl, resourceName)
  }

  private deleteFile(resourceId): void {
    PictureBookController.deletePictureBookResource(this.activeBookId, resourceId, this.activeType)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
      })
      .catch(err => {
        console.warn(err)
      })
      .finally(() => {
        const index = this.fileList.findIndex(file => file.resourceId === resourceId)
        this.fileList.splice(index, 1)
      })
  }

  private previewFile(url): void {
    window.open(url, '_blank')
  }
}
